import { render } from "./D3Chart.vue?vue&type=template&id=95b105e2"
import script from "./D3Chart.vue?vue&type=script&lang=js"
export * from "./D3Chart.vue?vue&type=script&lang=js"

import "./D3Chart.vue?vue&type=style&index=0&id=95b105e2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__